import React, { useState, useEffect } from 'react';
const CountdownToTomorrow = () => {
    const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            const tomorrow = new Date();
            tomorrow.setDate(now.getDate() + 1);
            tomorrow.setHours(0, 0, 0, 0); // Configurar el tiempo exacto a la medianoche de mañana

            const difference = tomorrow - now; // Diferencia en milisegundos

            if (difference <= 0) {
                clearInterval(interval); // Detener el intervalo cuando llegue el tiempo
                setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
            } else {
                const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((difference / (1000 * 60)) % 60);
                const seconds = Math.floor((difference / 1000) % 60);
                setTimeLeft({ hours, minutes, seconds });
            }
        }, 1000);

        return () => clearInterval(interval); // Limpiar el intervalo al desmontar el componente
    }, []);

    return (
        <>
            {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
        </>
    );
};

export default CountdownToTomorrow;